import { render, staticRenderFns } from "./BulkTransactionExport.vue?vue&type=template&id=6b10bec0"
import script from "./BulkTransactionExport.vue?vue&type=script&lang=js"
export * from "./BulkTransactionExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports